document.addEventListener('DOMContentLoaded', function (event) {
  initalizeMenu();
  closeMenu();
  scrollToTop();
});

function initalizeMenu() {
  document.querySelector('.Header-navigationClose, .MenuToggle').addEventListener('click', function () {
    let menu = document.querySelector('.Menu');
    if (menu.classList.contains('is-active')) {
      menu.classList.remove('is-active');
    } else {
      menu.classList.add('is-active');
    }
  });

  $('.Header-navigationItem-button').on('click', function () {
    $('.Header-navigationItem').not($(this).parent().parent()).removeClass('is-active');
    $(this).parent().parent().toggleClass('is-active');
  });
}

function closeMenu() {
  $('.Header-menu-blur').click(function () {
    $('.Menu').removeClass('is-active');
    $('.Header-navigationItem').removeClass('is-active');
  });
}

function scrollToTop() {
  document.querySelector('.MenuToggle-button').addEventListener('click', function () {
    window.scrollTo(0, 0);
  });
}
